
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { Helpers } from "@/global-scripts/helpers";
import { getModule } from "vuex-module-decorators";
import $ from "jquery";
/* eslint-disable-next-line */
import KeyDownEvent = JQuery.KeyDownEvent;
/* eslint-disable-next-line */
import KeyUpEvent = JQuery.KeyUpEvent;

import ContentModule from "@/store/modules/ContentModule";
import SearchModule from "@/store/modules/SearchModule";

@Component
export default class SearchInput extends Vue {
  private readonly searchModule = getModule(SearchModule, this.$store);

  @Prop({ default: "default" })
  identifier!: string;

  @Prop({ default: 0 })
  matchCount!: number;

  @Prop({ default: false })
  inModal!: boolean;

  private val = "";
  private isFocused = false;
  private hadValue = false; // Helps us determine escape key intent (search clear or close modal)

  private get searchModalOpen(): boolean {
    return this.searchModule.searchModalOpen;
  }

  private get inputID() {
    return `${this.identifier}-search-input`;
  }

  // Debounced local getter & setter for Search filter
  private get inputValue(): string {
    // Get from the store
    return this.inModal ? this.val : "";
  }

  private set inputValue(str: string) {
    if (str !== this.filter) {
      this.val = str;

      // Debounce filter setter
      Helpers.debounce(() => {
        if (this.val.length >= this.$config.searchMinChars) {
          // Entered a value
          this.filter = this.val;
        } else {
          this.filter = "";
        }
      }, this.$config.searchDebounceTime)();
    }
  }

  private get instructLabel() {
    if (this.inputValue && this.matchCount >= 0) {
      const matchCountString =
        this.matchCount === 1 ? this.$t.SearchMatchResultSingular : this.$t.SearchMatchResultPlural;

      return matchCountString.replace("{count}", this.matchCount.toString());
    } else {
      return this.$t.SearchInstructions;
    }
  }

  // Local getter & setter for Search filter
  private get filter(): string {
    // Get from the store
    return this.inModal ? this.searchModule.searchFilter : "";
  }

  private set filter(str: string) {
    str = str.trim();
    if (str !== this.searchModule.searchFilter) {
      // Dispatch store action
      this.searchModule.setSearchFilter(str);
      this.$emit("update");
    }
  }

  private get inputClasses(): string {
    const classes = [];

    if (this.inModal && this.isFocused) {
      classes.push("is-focused");
    }
    if (this.filter) {
      classes.push("show-clearButton");
    } else {
      classes.push("is-clickable");
    }
    if (this.filter && this.matchCount) {
      classes.push("has-matches");
    }
    return classes.join(" ");
  }

  private onKeyDown(evt: KeyDownEvent) {
    this.hadValue = evt.keyCode === 27 && this.filter.length > 0 && this.inModal;
  }

  private onKeyUp(evt: KeyUpEvent) {
    // Close modal on escape key, when we"re not clearing search value
    if (evt.keyCode === 27 && !this.hadValue && this.inModal) {
      this.searchModule.setSearchModalOpen(false);
    } else if (evt.keyCode === 27) {
      this.$emit("clear");
    } else if (evt.keyCode === 13) {
      // Enter key
      $(".SearchInput input").blur();
      this.$emit("enter");
    }
  }

  private onFocus() {
    if (!this.searchModalOpen) {
      this.searchModule.setSearchModalOpen(true);
    }
    this.isFocused = true;
    // Select all
    $(`#${this.inputID}`).select();
    //this.$emit("focus")
  }

  private onBlur() {
    this.isFocused = false;
    //this.$emit("blur")
  }

  private onClear() {
    this.clearInput();
    this.focusInput();
  }

  private clearInput() {
    this.inputValue = "";
  }

  private focusInput() {
    if (Helpers.mobilecheck()) {
      setTimeout(() => {
        $(`#${this.inputID}`).focus().select();
      }, 500);
    } else {
      $(`#${this.inputID}`).focus();
    }
  }

  created() {
    // Receive updates from parent
    this.$parent.$on("clearInput", this.clearInput);
    this.$parent.$on("focusInput", this.focusInput);
    this.$parent.$on("setFilterValue", (value: string) => {
      this.inputValue = value;
      $(`#${this.inputID}`).focus();
    });
    this.$parent.$on("updateInput", () => {
      this.$emit("input", this.filter);
    });

    this.$nextTick(() => {
      $(`#${this.inputID}`).focus(() => {
        this.$emit("focus");
      });
      $(`#${this.inputID}`).on("blur", () => {
        this.$emit("blur");
      });

      // If in modal, focus on create
      if (this.inModal && this.searchModalOpen) {
        this.focusInput();
      }
    });
  }
}
